import React from "react";
import { ArrayPath, FieldValues } from "react-hook-form";

import {
    BaseFieldArray,
    BaseFieldArrayChildProps
} from "../BaseFieldArray/baseFieldArray.component";
import { FormArrayValuesExploded } from "../formField.types";

export type MultiFileUploadFieldChildrenProps<T extends FieldValues> =
    BaseFieldArrayChildProps<T> & {
        disabled?: boolean;
    };

type MultiFileUploadProperties<T extends FieldValues> = {
    disabled?: boolean;
    children: (props: MultiFileUploadFieldChildrenProps<T>) => React.ReactNode;
};

export type MultiFileUploadFieldProps<T extends FieldValues> =
    FormArrayValuesExploded<T> & MultiFileUploadProperties<T>;

const MultiFileUploadField = <T extends FieldValues>({
    name,
    label,
    microCopy,
    required,
    disabled,
    children
}: MultiFileUploadFieldProps<T>) => {
    return (
        <BaseFieldArray<T, ArrayPath<T>>
            name={name}
            label={label}
            microCopy={microCopy}
            required={required}
        >
            {(props) => children({ ...props, disabled })}
        </BaseFieldArray>
    );
};

export { MultiFileUploadField };
